import { Component, Output, EventEmitter, Input } from '@angular/core';

@Component({
    selector: 'app-analytics-filter',
    templateUrl: './analytics-filter.component.html',
    styleUrls: ['./analytics-filter.component.scss'],
    standalone: false
})
export class AnalyticsFilterComponent {
    @Input() categories: any[] = [];
    @Output() filterChanged = new EventEmitter<any>();

    selectedCategory: string = '';
    startDate: Date | null = null;
    endDate: Date | null = null;

    constructor() { }

    onFilterChange() {
        this.filterChanged.emit({
            category: this.selectedCategory,
            startDate: this.startDate,
            endDate: this.endDate
        });
    }

    resetFilters() {
        this.selectedCategory = '';
        this.startDate = null;
        this.endDate = null;
        this.onFilterChange();
    }
}
